import React from "react";
import ServicesBanner from "../components/services/services-banner";
import ServiceDescriptionFull from "../components/services/service-description-full";
import ServicesSupplySolutions from "../components/services/services-Supply-solutions";

const Services = () => {
  return (
   <>
    <ServicesBanner />
    <ServiceDescriptionFull />
    <ServicesSupplySolutions />
   </>
  );
};

export default Services;